export default __webpack_public_path__ + "static/media/mainResume-carlosAPerez.89259868.pdf";